import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  protected defaultController = `${environment.baseUrl}/api/`;
  protected slug = 'order';
  constructor(public http: HttpClient, private snackBar: MatSnackBar) {
  }

  public addGoldOrder(payload: any): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}/gold`, payload);
  }

  public addAccountOrder(payload: any): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}/account`, payload);
  }

  public getGoldOrders(pageNumber: number = 1): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}/gold?pageNumber=${pageNumber}`);
  }

  public getAccountOrders(pageNumber: number = 1): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}/account?pageNumber=${pageNumber}`);
  }

  public getSingleOrder(id): Observable<any> {
    return this.http.get(`${this.defaultController}orders/${id}`);
  }

  public getOrder(id: string): Observable<any> {
    return this.http.get<any>(`${this.defaultController}${this.slug}/${id}`);
  }

  public getStatistics(): Observable<any> {
    return this.http.get<any>(`${this.defaultController}orders/statistics`);
  }

  public updateOrder(id): Observable<any> {
    return this.http.put(`${this.defaultController}${this.slug}/${id}`, null).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss', {
          duration: 5000,
        });
      }));
  }

  public resolveOrder(id): Observable<any> {
    return this.http.put(`${this.defaultController}${this.slug}/${id}/resolve`, null).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss', {
          duration: 5000,
        });
      }));
  }

  public deleteOrder(id): Observable<any> {
    return this.http.delete(`${this.defaultController}${this.slug}/${id}`).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss', {
          duration: 5000,
        });
      }));
  }
} 